import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';

export const createQuote = async form => {
    return await Api.createQuote(form);
};

export const getQuote = async quoteId => {
    return await Api.getQuote(quoteId);
};

export const shareQuote = async (quoteId, share) => {
    return await Api.shareQuote(quoteId, share);
};



// WEBPACK FOOTER //
// ./src/modules/quote/QuoteActions.js